import { render, staticRenderFns } from "./LanguageSwitcher.vue?vue&type=template&id=295455de"
import script from "./LanguageSwitcher.vue?vue&type=script&lang=js"
export * from "./LanguageSwitcher.vue?vue&type=script&lang=js"
import style0 from "./LanguageSwitcher.vue?vue&type=style&index=0&id=295455de&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/viparabclub/releases/20251208210823/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('295455de')) {
      api.createRecord('295455de', component.options)
    } else {
      api.reload('295455de', component.options)
    }
    module.hot.accept("./LanguageSwitcher.vue?vue&type=template&id=295455de", function () {
      api.rerender('295455de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/LanguageSwitcher.vue"
export default component.exports